import { tap } from 'rxjs/operators';

export const tapConsole = () => tap((res) => {
  console.log(res);
});
